<div class="status-block isf" *ngIf="!!status && !status.isES">
  <div class="first-text {{ status?.firstTextColor }}" [ngClass]="{ triangle: !!status?.secondText }">
    {{ status?.firstText | translate }}
  </div>
  <ng-container *ngIf="status?.secondText">
    <ng-container *ngIf="status?.pointColor">
      <div class="point {{ status?.pointColor }}"></div>
    </ng-container>
    <div class="hint-text">{{ status?.secondText | translate }}</div>
  </ng-container>
</div>

<div class="status-block es" *ngIf="!!status && status.isES">
  <div
    class="first-text {{ status?.firstTextColor }}"
    *ngIf="!!status?.firstText"
    [ngClass]="{ triangle: !!status?.hintText || !!status?.secondText }"
  >
    {{ status?.firstText | translate }}
  </div>
  <div
    *ngIf="status?.secondText"
    class="second-text {{ status?.secondTextColor }}"
    [ngClass]="{ 'without-first-text': !status?.firstText }"
  >
    {{ status?.secondText | translate }}
  </div>
  <ng-container *ngIf="status?.hintText">
    <ng-container *ngIf="status?.pointColor">
      <div class="point {{ status?.pointColor }}"></div>
    </ng-container>
    <div class="hint-text {{ status?.hintTextColor }}" [ngClass]="{ 'without-first-text': !status?.secondText }">
      {{ status?.hintText | translate }}
    </div>
  </ng-container>
</div>
